import { Box } from '@factorialco/deprecated-design-system'

import * as Dialog from '@radix-ui/react-dialog'
import FallbackPlaceholder from 'modules/get_started/components/TaskItem/_FallbackPlaceholder'

type VideoInfo = {
  embedUrl: string
  thumbnailUrl: string | null
}

const getVideoInfo = (url: string): VideoInfo | null => {
  const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/)
  if (youtubeMatch?.[1]) {
    return {
      embedUrl: `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`,
      thumbnailUrl: `https://img.youtube.com/vi/${youtubeMatch[1]}/mqdefault.jpg`,
    }
  }

  const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/)
  if (driveMatch?.[1]) {
    return {
      embedUrl: `https://drive.google.com/file/d/${driveMatch[1]}/preview`,
      thumbnailUrl: null,
    }
  }

  return null
}

const PlayButton = () => (
  <Box
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      style={{
        width: '0',
        height: '0',
        borderTop: '16px solid transparent',
        borderBottom: '16px solid transparent',
        borderLeft: '28px solid rgba(255, 255, 255, 0.8)',
        marginLeft: '3px',
      }}
    />
  </Box>
)

type Props = {
  videoUrl: string
  title: string
  onOpen: () => void
}

const VideoThumbnail = ({ videoUrl, title, onOpen }: Props) => {
  const info = getVideoInfo(videoUrl)
  if (!info) return <FallbackPlaceholder title={title} />

  return (
    <Dialog.Root
      onOpenChange={(open) => {
        if (open) onOpen()
      }}
    >
      <Dialog.Trigger asChild>
        <Box
          style={{
            width: '260px',
            height: '160px',
            borderRadius: '8px',
            overflow: 'hidden',
            flexShrink: '0',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <Box
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#E51943',
              backgroundImage: info.thumbnailUrl ? `url(${info.thumbnailUrl})` : undefined,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <Box
            style={{
              position: 'absolute',
              inset: '0',
              backgroundColor: 'rgba(229, 25, 67, 0.75)',
            }}
            alignItems="center"
            justifyContent="center"
            padding="s12"
          >
            <Box
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                textAlign: 'center',
                lineHeight: '1.3',
                fontSize: '13px',
                fontWeight: '500',
              }}
            >
              {title}
            </Box>
          </Box>
          <PlayButton />
        </Box>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0, 0, 0, 0.7)',
          }}
        />
        <Dialog.Content
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999,
            width: '80vw',
            maxWidth: '900px',
            aspectRatio: '16 / 9',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
        >
          <Box style={{ width: '100%', height: '100%' }}>
            <iframe
              src={info.embedUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
              allow="autoplay; encrypted-media"
              allowFullScreen
              title={title}
            />
          </Box>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default VideoThumbnail
